<template>
  <div :key="$route.params.page">
    <v-alert v-if="showRelatedMessage" :value="true" color="success" type="success">
      Skjemaet er ferdig utfylt med info fra innflyttingsprotokoll
    </v-alert>
    <dynamicComponent
      v-for="(component, index) in pageSetup"
      :key="id+'_'+index"
      :comp="component"
      :stepValues="stepValues"
      :relatedStepValues="relatedStepValues"
      @previous-page="previous"
      @next-page="next"
      @save-state="saveState"
      @update-fields="updateFields"
      @error="error"
    />
  </div>
</template>

<script>
import step from "../../mixins/step";
import dynamicComponent from "../DynamicComponent";
import dynamicEvents from "../../mixins/dynamicEvents"
export default {
  props: ["protocol", "step", "stepValues", "relatedStepValues"],
  mixins: [step, dynamicEvents],
  components: {dynamicComponent},
  data() {
    return {
      pageSetup: [],
      id: null
    };
  },
  beforeMount() {
    this.fixPage()
  },
  methods: {
    fixPage() {
      if (this.step.pivot.config) {
        let config = JSON.parse(this.step.pivot.config);
        let pageItems = [];
        if(config.pageSetup) {
          for (let pageItem in config.pageSetup) {
            this.setupPageItem(config.pageSetup[pageItem]);
          }
          this.pageSetup = config.pageSetup
        }
      }
    },
    setupPageItem(pageItem) {
      for (let prop in pageItem.props) {
        pageItem.props[prop] = eval(pageItem.props[prop]);
      }
      if (pageItem.children) {
        for (let child in pageItem.children) {
          this.setupPageItem(pageItem.children[child])
        }
      }
    },
    next: function() {
      let finished = true
      for (let child in this.$children) {
        let compFin = this.checkComponentFinished(this.$children[child])
        if(!compFin) {
          finished = false
        }
      }
      if(finished) {
        this.$emit('next-page')
      }
    },
    checkComponentFinished(component) {
      let finished = true
      try {
        finished = component.isFinished()
      }
      catch (error) {
        finished = true
        // this component has no isFinished methos so setting true
      }
      
      for (let child in component.$children) {
        let childFinished = true        
        try {
          childFinished = this.checkComponentFinished(component.$children[child])
        } catch (error) {
          childFinished = true
        }
        if(!childFinished) {
          finished = false
        }
      }
      return finished
    }
  },
  computed: {
    showRelatedMessage: function() {
      if(this.protocol.related_protocol && this.relatedStepValues) {
        return true
      }
      return false
    }
  }
};
</script>